import { render, staticRenderFns } from "./myHelp.vue?vue&type=template&id=77b64e3f&scoped=true"
import script from "./myHelp.vue?vue&type=script&lang=js"
export * from "./myHelp.vue?vue&type=script&lang=js"
import style0 from "./myHelp.vue?vue&type=style&index=0&id=77b64e3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b64e3f",
  null
  
)

export default component.exports